import { useCallback, useEffect, useState } from 'react';
import IFeatureFlagProps from './interfaces/IFeatureFlagProps';
import IFeatureFlags from './interfaces/IFeatureFlags';
import ConfigurationManager from '../../../utils/configurationManager';

function FeatureFlagComponent({
    feature,
    children,
}: Readonly<IFeatureFlagProps>): JSX.Element {
    const [features, setFeatures] = useState<IFeatureFlags[]>(
        [] as IFeatureFlags[],
    );

    const setFeatureFlagConfigs = useCallback(async () => {
        const { FEATURE_FLAGS } =
            await ConfigurationManager.getInstance().getConfigFile();
        setFeatures(FEATURE_FLAGS);
    }, [setFeatures]);

    const isEnabled = (): boolean => {
        return features?.some(l => l.name === feature && l.active === 'true');
    };

    useEffect(() => {
        if (features.length === 0) {
            setFeatureFlagConfigs();
        }
    }, [features, setFeatureFlagConfigs]);

    if (children === false) {
        return <></>;
    }

    return isEnabled() ? children : <></>;
}

export default FeatureFlagComponent;
